import { Link, useNavigate } from 'react-router-dom';
import {
  FaInstagram,
  FaEnvelope,
  FaMapMarkerAlt,
  FaHeart,
  FaWhatsapp
} from 'react-icons/fa';
import { trackContactClick } from '../utils/analytics';
import '../styles/Footer.css';

const STORE_EMAIL = 'celestialstones33@gmail.com';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (e, id) => {
    e.preventDefault();

    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // Section only exists on the home page.
    navigate('/', { state: { scrollTo: id } });
  };

  return (
    <footer className="footer" id='footer'>
      <div className="footer-container">
        <div className="footer-content">

          {/* BRAND */}
          <div className="footer-section footer-brand">
            <h3 className="footer-title">Celestial Stones</h3>
            <p className="footer-description">
              Discover celestial gemstones aligned with planetary energies,
              crafted to elevate your destiny.
            </p>

            <div className="social-links">
              <a
                href="https://www.instagram.com/stones.celestial?igsh=MTY4ZGZ1cmd1MzNrcw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                onClick={() => trackContactClick('instagram', 'footer_social')}
              >
                <FaInstagram />
              </a>

                <a
                href="https://WA.me/918796592272"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                onClick={() => trackContactClick('whatsapp', 'footer_social')}
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <a href="#home" onClick={(e) => scrollToSection(e, '#home')}>
                  Home
                </a>
              </li>
              <li>
                <a href="#collection" onClick={(e) => scrollToSection(e, '#collection')}>
                  Collection
                </a>
              </li>
              <li>
                <a href="#about" onClick={(e) => scrollToSection(e, '#about')}>
                  About
                </a>
              </li>
              <li>
                <a href="#footer" onClick={(e) => scrollToSection(e, '#footer')}>
                  Contact
                </a>
              </li>
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/cart">Cart</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>

          {/* SUPPORT */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Support</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service">Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/shipping-returns">Shipping &amp; Returns</Link>
              </li>
              <li>
                <Link to="/cookie-policy">Cookie Policy</Link>
              </li>
              <li>
                <Link to="/data-request">Data &amp; Privacy Requests</Link>
              </li>
              <li>
                <Link to="/account">My Account</Link>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="footer-section footer-contact">
            <h4 className="footer-subtitle">Contact Us</h4>

            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <p>Delhi,India</p>
              </div>

              <div className="contact-item">
                <FaWhatsapp className="contact-icon" />
                <a
                  href="https://WA.me/918796592272"
                  onClick={() => trackContactClick('whatsapp', 'footer_contact')}
                >
                  +91 87965 92272
                </a>
              </div>

              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <a
                  href={`mailto:${STORE_EMAIL}`}
                  onClick={() => trackContactClick('email', 'footer_contact')}
                >
                  Mail Us
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* FOOTER BOTTOM */}
        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} Celestial Stones
            <FaHeart className="heart-icon" />
          </div>

          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy</Link>
            <span>|</span>
            <Link to="/cookie-policy">Cookies</Link>
            <span>|</span>
            <Link to="/terms-of-service">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
